import React, { useEffect, useState } from "react";
import { Formik, Form, useFormikContext, useFormik } from "formik";
import { step1FormSchema } from "./form-schema";
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Divider,
  Container,
  Avatar,
  Button,
  FormControl,
  FormHelperText,
} from "@mui/material";
import { Box } from "@mui/system";
import { BasicSelect, SearchSelect, TextInput, DateInput } from "./components";
import ImageUpload from "./components/image-upload";
import { selectState, selectDistrict } from "../Actions/CommonAction";
import { singleCandidatesDetails } from "../Actions/CandidateAction";
import { token } from "../Actions/AuthAction";

function ProfilePic({ onImageSelect, profilePic }) {
  const { errors } = useFormikContext();
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Avatar src={profilePic} sx={{ width: 120, height: 120 }} />
      <ImageUpload onImageSelect={onImageSelect} />
    </Container>
  );
}

function PersonalDetails() {
  const { values, setFieldValue } = useFormikContext();

  function onImageSelect(imageList) {
    setFieldValue("profilePicUrl", imageList[0].data_url);
  }

  return (
    <Card>
      <Typography sx={{ px: 2, py: 1, m: 0 }} variant="subtitle2" gutterBottom>
        Personal Details
      </Typography>
      <Divider />
      <CardContent>
        <Grid container spacing={2}>
          <Grid item md={3} xs={12}>
            <ProfilePic
              label="Profile Pic"
              name="profilePicUrl"
              profilePic={values.profilePicUrl}
              onImageSelect={onImageSelect}
            />
          </Grid>
          <Grid item md={9} xs={12}>
            <Grid container spacing={2} mb={1.5}>
              <Grid item xs={6}>
                {/* <label className="card p-2 ">jsidjoi</label> */}
                <TextInput
                  label="First Name"
                  name="firstName"
                  type="text"
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextInput
                  label="Middle Name"
                  name="middleName"
                  type="text"
                  disabled
                />
              </Grid>
              <Grid item xs={6}>
                <TextInput
                  label="Last Name"
                  name="lastName"
                  type="text"
                  disabled
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mb={1.5}>
              <Grid item xs={6}>
                <DateInput label="Date of Birth" name="dob" disabled />
              </Grid>
              <Grid item xs={6}>
                <BasicSelect
                  label="Gender"
                  name="gender"
                  options={[
                    { label: "Male", value: "male" },
                    { label: "Female", value: "female" },
                  ]}
                  disabled
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mb={1.5}>
              <Grid item xs={6}>
                <TextInput label="Email" name="email" type="email" disabled />
              </Grid>
              <Grid item xs={6}>
                <TextInput
                  label="Phone Number"
                  name="phoneNumber"
                  type="text"
                  disabled
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} mb={1.5}>
              <Grid item xs={6}>
                <TextInput
                  label="Father's Name"
                  name="fatherName"
                  type="text"
                />
              </Grid>
              {/* <Grid item xs={6}>
                <TextInput
                  label="Aadhar Number"
                  name="aadharNumber"
                  type="text"
                />
              </Grid> */}
              <Grid item xs={6}>
                <TextInput
                  label="Alternate Number"
                  name="altNumber"
                  type="text"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

// function UniversityDetails() {
//   return (
//     <Card>
//       <Typography sx={{ px: 2, py: 1, m: 0 }} variant="subtitle2" gutterBottom>
//         Preffered Location
//       </Typography>
//       <Divider />
//       <CardContent>
//         <Grid container spacing={2}>
//           <Grid item xs={4}>
//             <TextInput
//               label="Prefered Location"
//               name="preferedLocation"
//               type="text"
//             />
//           </Grid>
//         </Grid>
//       </CardContent>
//     </Card>
//   );
// }

function LocationDetails({
  states,
  cities,
  fetchCities,
  fetchStates,
  isFetchingStates,
  isFetchingCities,
}) {
  const { values } = useFormikContext();

  return (
    <Card>
      <Typography sx={{ px: 2, py: 1, m: 0 }} variant="subtitle2" gutterBottom>
        Location Details
      </Typography>
      <Divider />
      <CardContent>
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12}>
            <TextInput fullWidth label="Address" name="address" type="text" />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4}>
            <SearchSelect
              onMenuOpen={fetchStates}
              isLoading={isFetchingStates}
              label="State"
              name="state"
              options={states}
            />
          </Grid>
          <Grid item xs={4}>
            <SearchSelect
              isDisabled={!values.state}
              isLoading={isFetchingCities}
              onMenuOpen={() => fetchCities(values.state)}
              label="City"
              name="city"
              options={cities}
            />
          </Grid>
          <Grid item xs={4}>
            <TextInput label="Pincode" name="pincode" type="text" />
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

const initialData = {
  profilePicUrl: "",
  firstName: "",
  middleName: "",
  lastName: "",
  dob: "",
  gender: "",
  fatherName: "",
  aadharNumber: "",
  altNumber: "",
  email: "",
  phoneNumber: "",
  address: "",
  city: null,
  state: null,
  pincode: "",
};

function Step1({ getFormValidity, getData, data }) {
  const [states, setStates] = useState([]);
  const [isFetchingStates, setIsFetchingStates] = useState(false);
  const [isFetchingCities, setIsFetchingCities] = useState(false);
  const [cities, setCities] = useState([]);
  const [isInitialValid, setIsInitialValid] = useState(false);
  const [candData, setCandData] = useState(false);

  const { validateForm } = useFormik({
    validationSchema: step1FormSchema,
    initialValues: getInitialData(),
  });

  useEffect(() => {
    validateInitial();
    const model = { loginusertoken: token(), id: "" };
    singleCandidatesDetails(model).then((res) => {
      const candidateDetails = res.data[0];
      initialData.firstName = candidateDetails.firstname;
      initialData.lastName = candidateDetails.lastname;
      initialData.gender = candidateDetails.gender == 1 ? "male" : "female";
      initialData.dob = candidateDetails.dob.split(" ")[0];
      initialData.middleName = candidateDetails.middlename;
      initialData.phoneNumber = candidateDetails.user.phone;
      initialData.email = candidateDetails.user.email;
      //  initialData.firstName=candidateDetails.firstname;
      setCandData(true);
    });
  }, []);

  async function validateInitial() {
    const response = await validateForm();
    setIsInitialValid(Object.values(response).length === 0);
  }

  function getInitialData() {
    return Object.values(data).length ? data : initialData;
  }

  function getInitialData() {
    return Object.values(data).length ? data : initialData;
  }

  async function fetchStates() {
    setIsFetchingStates(true);
    const response = await selectState({ status: 1 });
    const data = response.data.map(({ name, state_id }) => ({
      label: name.charAt(0).toUpperCase() + name.slice(1).toLowerCase(),
      value: state_id,
    }));
    setStates(data);
    setIsFetchingStates(false);
  }

  async function fetchCities({ value }) {
    setIsFetchingCities(true);
    const response = await selectDistrict({ state_id: value });
    const data = response.data.map(({ name, district_id }) => ({
      label: name.charAt(0).toUpperCase() + name.slice(1).toLowerCase(),
      value: district_id,
    }));
    setCities(data);
    setIsFetchingCities(false);
  }

  return (
    <Formik
      initialValues={getInitialData()}
      validationSchema={step1FormSchema}
      isInitialValid={isInitialValid}
    >
      {({ isValid, values }) => {
        getData(1, values);
        getFormValidity(isValid);
        return (
          <Form>
            <Box mb={3}>
              <PersonalDetails />
            </Box>
            <Box my={3}>
              <LocationDetails
                isFetchingStates={isFetchingStates}
                isFetchingCities={isFetchingCities}
                fetchStates={fetchStates}
                fetchCities={fetchCities}
                states={states}
                cities={cities}
              />
            </Box>
          </Form>
        );
      }}
    </Formik>
  );
}

export default Step1;
